// Fake "Sign in with Google" screen (UC-01). No real OAuth — tapping the button
// opens an account chooser listing seeded fake Google accounts; picking one
// signs in as that persona and enters the app.

import $ from 'jquery';
import type { Screen } from './types';
import { api } from '../api';
import { signIn } from '../session';
import { navigate } from '../router';
import { avatarHtml, esc } from '../ui/dom';

export const SignInScreen: Screen = async (body) => {
  body.html(`
    <div class="signin">
      <div class="signin__brand">
        <div class="signin__logo">🏀</div>
        <div class="signin__name">Hoops<span>Match</span></div>
        <div class="signin__tag">Ankara'da basket oyununu bul, eksik oyuncuyu tamamla.</div>
      </div>
      <div class="signin__actions">
        <button class="gbtn" id="google-signin">
          <span class="gbtn__g">G</span>
          <span>Google ile giriş yap</span>
        </button>
        <div class="signin__note">Demo · gerçek giriş yapılmaz</div>
      </div>
      <div class="chooser" id="chooser" hidden>
        <div class="chooser__backdrop"></div>
        <div class="chooser__sheet">
          <div class="chooser__title">Hesap seç</div>
          <div id="chooser-list"></div>
          <button class="btn btn--ghost btn--block" id="chooser-cancel">Vazgeç</button>
        </div>
      </div>
    </div>
  `);

  const accounts = await api.call('auth.googleAccounts', undefined);

  const listHtml = accounts
    .map(
      (a) => `
      <button class="chooser__acc" data-id="${esc(a.id)}">
        ${avatarHtml(a.displayName, a.avatarUrl, 40)}
        <span class="chooser__acc-text">
          <span class="chooser__acc-name">${esc(a.displayName)}</span>
          <span class="chooser__acc-email">${esc(a.email)}</span>
        </span>
      </button>`,
    )
    .join('');
  $('#chooser-list').html(listHtml);

  const $chooser = $('#chooser');
  $('#google-signin').on('click', () => $chooser.prop('hidden', false));
  $('#chooser-cancel, .chooser__backdrop').on('click', () => $chooser.prop('hidden', true));

  $('#chooser-list').on('click', '.chooser__acc', async function () {
    const id = $(this).data('id') as string;
    $(this).addClass('is-loading');
    await signIn(id);
    navigate('/home');
  });
};
